import api from '@/shared/api';

export async function getDocumentPrefixes(): Promise<any[]> {
  try {
    const response = await api.get('/document-prefixes');
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching document prefixes:', error);
    throw error;
  }
}
